import { useMutation } from '@tanstack/react-query';
import { markMaterialView } from '../queries/materials';
import { MaterialViewType, ViewOrigin } from '../models/contentView';

interface IFinishMaterialParams {
  slug: string;
  type?: MaterialViewType;
  origin?: ViewOrigin;
}

export function useFinishMaterial() {
  const { mutate, isPending, isSuccess, data } = useMutation({
    mutationKey: ['finish-material-from-card'],
    mutationFn: ({ slug, type, origin }: IFinishMaterialParams) =>
      markMaterialView(slug, type, origin),
    retry: false,
  });

  return { mutate, isPending, isSuccess, data };
}
